import { AppConstants } from '@app/app.constants';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookiesService } from '@services/cookies/cookies.service';
import { InstructionsService } from '@app/services/contents/instructions/instructions.service';
import { ListComponent } from '../base/list.component';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '@environment/environment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    imports: [CommonModule, RouterLink, TranslateModule],
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent extends ListComponent implements OnInit {
    private readonly cookiesService: CookiesService = inject(CookiesService);
    private readonly instructionsService: InstructionsService = inject(InstructionsService);
    private readonly translate: TranslateService = inject(TranslateService);
    public year: number = new Date().getFullYear();
    public version: string = environment.version;

    constructor() {
        super();
        this.items = this.instructionsService.entities.pipe(takeUntilDestroyed());
    }

    public override ngOnInit(): void {
        super.ngOnInit();
        this.instructionsService.readItems();
    }

    public onChangeLanguage(lang: string): void {
        this.translate.use(lang);
        this.cookiesService.setCookie(AppConstants.USER_LANGUAGE, lang);
    }
}
